import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Result, Button } from 'antd';

interface IProps extends RouteComponentProps {};

export default function Index(props: IProps) {
  function goHome() {
    props.history.push('/');
  }
  return (
    <Result
      status="404"
      title="404"
      subTitle="不好意思，您访问的页面不存在！"
      extra={<Button type="primary" onClick={goHome}>去首页</Button>}
    />
  )
}